import '@babel/polyfill'
import Vue from 'vue'
import './plugins/axios'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'

// service worker was causing more trouble than it was worth. Disabling until the implementation can be improved
// import './registerServiceWorker'
import dictaComponents from 'dicta-vue-components'

Vue.config.productionTip = false

const isDev = process.env.NODE_ENV === "development"
Vue.config.performance = isDev

Vue.use(dictaComponents, { hebrew: true })
Vue.use(VueCookies)

import VueHotkey from 'v-hotkey'
Vue.use(VueHotkey)

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

// NOTE: We do use VuexUndoRedo, and therefore I think it's "nice" to pull the code with package.json (so we do).
// ----  However, I do not import it here, but rather use its code as a mixin only for the NikudResultsContainer.
// ----  Otherwise, it's "mixed in" to ALL the components, which seems like a huge waste, and besides, I made a
// ----  small but crucial change to the code -- see the mixin file. -- DL
// import VuexUndoRedo from 'vuex-undo-redo'
// Vue.use(VuexUndoRedo, { ignoreMutations: mutationsToIgnore })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
